import React from 'react';
import { ShieldCheck, Clock, BadgeDollarSign, ThumbsUp } from 'lucide-react';
const REASONS = [{
  title: 'Safe Soft-Wash Methods',
  description: 'We use low-pressure techniques and eco-friendly solutions to protect your delicate surfaces while eliminating grime.',
  icon: ShieldCheck
}, {
  title: 'Professional Crews',
  description: 'On-time, uniformed, and respectful technicians who treat your property like it was their own.',
  icon: Clock
}, {
  title: 'Upfront Flat-Rate Pricing',
  description: 'No hidden fees or surprise charges. The price we quote is the price you pay, guaranteed.',
  icon: BadgeDollarSign
}, {
  title: 'Satisfaction Guaranteed',
  description: 'We are not finished until you are thrilled with the results. Job done right, every time.',
  icon: ThumbsUp
}];
export function WhyUs() {
  return <section className="py-24 bg-dark relative" data-id="element-254">
      <div className="container mx-auto px-4" data-id="element-255">
        <div className="text-center mb-16" data-id="element-256">
          <h2 className="font-display text-4xl md:text-5xl text-white uppercase tracking-wide mb-4" data-id="element-257">
            Why Choose <span className="text-accent" data-id="element-258">Joel Reynolds</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-259">
          {REASONS.map((reason, idx) => <div key={idx} className="flex flex-col items-center text-center relative" data-id="element-260">
              <div className="h-20 w-20 rounded-full bg-surface border-2 border-accent flex items-center justify-center mb-6 shadow-[0_0_20px_rgba(220,38,38,0.15)]" data-id="element-261">
                <reason.icon className="h-10 w-10 text-accent" data-id="element-262" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-263">
                {reason.title}
              </h3>
              <p className="text-slate-400" data-id="element-264">{reason.description}</p>
              {idx < REASONS.length - 1 && <div className="hidden lg:block absolute top-10 -right-4 w-8 h-px bg-accent/30" data-id="element-265" />}
            </div>)}
        </div>
      </div>
    </section>;
}